// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LDxW","left":"styles_left__2cTIZ"};